export default __webpack_public_path__ + "static/washLogo-1fa3454e040283da8d87aac92bec0e73.png";